export default __webpack_public_path__ + "static/media/login-brand-image-7-white.9da47505.jpg";